import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { ADMIN_BASE } from "../../config";

export default function ProtectedRoute({ children }) {
    const { admin } = useAuth();

    if (admin === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-[#070c18] text-slate-300/60">
                Loading…
            </div>
        );
    }
    // Signed out, or signed in but not yet approved → send back to the portal gate.
    if (!admin || admin.status !== "approved") {
        return <Navigate to={ADMIN_BASE} replace />;
    }
    return children;
}
